module.exports = __webpack_public_path__ + "media/images/weather/650_day-eebb08ab1758c97b14bc6b5d19e0a710.png";